<template>
  <div class="border">
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/conditionals`;
    this.setLink += `/${this.id}/conditionals`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "conditionals",
          label: "Выберите условия партнеров",
          type: "selects",
          modal: "conditional",
          selectKey: "title",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_conditional",
      itemLink: "promotions",
      setLink: "promotions",
      columns: [
        {
          key: "partner",
          title: "Условие",
          object: "name",
          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "month",
          title: "Период (М)",

          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "coefficient",
          title: "Процент (%)",

          checkbox: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
